<template>
  <div>
    <el-upload
      class="avatar-uploader"
      :action="actionUrl"
      :show-file-list="false"
      :http-request="handleAvatarSuccess"
      :before-upload="beforeAvatarUpload"
      v-loading.fullscreen.lock="loading"
    >
      <div ref="cameraIcon" class="camera-icon has-image">
        <img src="@/assets/images/camera-icon-white.svg" />
        <h2>
          <slot name="label">
          {{ label || $t('user_profile.your_profile.modals.edit_profile.upload_image.label') }}
          </slot>
        </h2>
      </div>
      <img v-if="image !== ''" :src="image" class="avatar-uploader-icon">
      <img v-else-if="logo_url" :src="logo_url" class="avatar-uploader-icon">
      <img v-else src="@/assets/images/org-example.png" class="avatar-uploader-icon">
    </el-upload>
  </div>
</template>

<script>
import { mapActions } from "vuex";
import { warningMessage, successMessage } from "../../utils/messages";
import { uploadFile, readFile } from "../../utils/uploader";
export default {
  props: {
    label: {
      type: String,
      default: null
    },
    logo_url: {
      type: String,
      default: null
    },
    organizationId: {
    }
  },
  data() {
    return {
      image: '',
      actionUrl: "",
      uploadId: "",
      loading: false,
    }
  },
  methods: {
    async handleAvatarSuccess(res) {
      try {
        this.$refs.cameraIcon.classList.add('has-image');
        const { action: url, file } = res;
        const base64 = await this.getBase64(file)
        const rawFile = await readFile(file);
        await uploadFile(url, file.type, rawFile);
        this.$emit('uploadAvatar', this.uploadId);
        this.loading = false;
        return true
      } catch (e) {
        this.$message.error(e)
        this.loading = false;
        return warningMessage(this.$t("common.generic_error_message"))(this);
      }
    },
    async beforeAvatarUpload(file) {
      // const isLt2M = file.size / 1024 / 1024 < 2
      // const isImage = ['image/jpeg', 'image/png', 'image/gif'].includes(file.type)
      // if (!isImage) {
      //   this.$toast.error('Avatar picture must be an image!')
      // }
      // if (!isLt2M) {
      //   this.$toast.error('Avatar picture size can not exceed 2MB!')
      // }

      // return isLt2M && isImage
      const fileSize = file.size;
      const contentType = file.type;
      const fileName = file.name;
      const payload = {
        fileSize,
        contentType,
        // fileName,
        organizationId: this.organizationId
      };
      try {
        this.loading = true;
        const req = await this.getLogoUploadUrl({
          ...payload
        });
        this.$refs.cameraIcon.classList.add('has-image');
        this.actionUrl = req.data.presigned_url;
        this.uploadId = req.data.callback_id;
      } catch (e) {
        // show warning
        // please try again
        this.errors = true;
        this.loading = false;
        warningMessage(this.$t("common.generic_error_message"))(this);
        return Promise.reject(false);
      }
    },
    getBase64(file) {
      return new Promise((resolve, reject) => {
        const reader = new FileReader()
        reader.readAsDataURL(file)
        reader.onload = () => {
          this.image = reader.result
          resolve(reader.result)
        }
        reader.onerror = error => reject(error)
      })
    },
    ...mapActions("organization", [
      "getLogoUploadUrl",
    ]),
  }
}
</script>
<style lang="scss">
  @import "../../scss/_colors.scss";
  .el-dialog.elsa-modal .el-dialog__body .camera-icon h2 {
    text-align: center;
  }

  .avatar-uploader .el-upload.el-upload--text {
    width: 100%;
    height: 100%;
    display: flex;
    justify-content: center;
    align-items: center;
  }

  .camera-icon {
    margin: auto;
    position: absolute;
    width: 100%;
    height: 100%;
    text-align: center;

    &.has-image {
      opacity: 0;
    }

    &.has-image:hover {
      opacity: 1;
      background: rgba(181, 88, 255, 0.5);
      border-radius: 50%;

      h2 {
        opacity: 1;
        font-weight: 300;
        font-size: 16px;
        color: #FFFFFF;
      }
    }

    h2 {
      text-align: center;
    }

    img {
      margin-top: 30px;
    }
  }

  .square .avatar-uploader{
    border-radius: 0;
    h2 {
      padding-top: 14px;
    }
    .camera-icon.has-image:hover {
      border-radius: 0;
    }
    .avatar-uploader-icon {
      border-radius: 0;
    }
  }

  .avatar-uploader {
    background-color: white;
    height: 112px;
    width: 112px;
    position: relative;
    display: flex;
    justify-content: center;
    align-items: center;
    border: 1px solid $light-blue;
    border-radius: 50%;
    margin: 0 auto;

    h2 {
      text-align: center;
      text-transform: capitalize;
      font-weight: 300;
      font-size: 16px;
      color: $darker-blue;
      opacity: 0.5;
    }

    .avatar-uploader-icon {
      width: 112px;
      height: auto;
      border-radius: 50%;
      height: 112px;
    }
  }
</style>
